import React, { useRef, useState } from 'react';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Portal from '@mui/material/Portal';
import apiUrl from '../Apiurl';
import { resolveTranslationUsername } from '../traduzioni/translationRequest';

function RiciclaCiecamente({ idProd, trad, setProductFunction, cambiaStato, utente }) {
    const { user, getAccessTokenSilently } = useAuth0();
    const richiestaInCorso = useRef(false);
    const [inCorso, setInCorso] = useState(false);
    const [errore, setErrore] = useState('');
    const [codDaRiciclare, setCodDaRiciclare] = useState('');

    async function ricicla() {
        if (richiestaInCorso.current || trad) return;
        const codiceDaRiciclare = codDaRiciclare.trim();
        setErrore('');
        if (!codiceDaRiciclare) {
            setErrore('Inserisci il codice da cui riciclare le traduzioni.');
            return;
        }
        richiestaInCorso.current = true;
        setInCorso(true);
        try {
            const accessToken = await getAccessTokenSilently();
            const username = await resolveTranslationUsername({
                username: utente?.username,
                email: user?.email,
                accessToken,
            });
            const response = await axios.patch(
                `${apiUrl}/prodotti/translate/ricicla`,
                { idProd, codiceDaRiciclare },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'X-Domino-Username': username,
                    },
                },
            );
            cambiaStato(response.data);
            setProductFunction(response.data);
        } catch (error) {
            setErrore(error?.response?.data?.error || error?.message ||
                'Errore durante il riciclo delle traduzioni.');
        } finally {
            richiestaInCorso.current = false;
            setInCorso(false);
        }
    }

    const classe = `material-icons md-13 tastiVicinoInput button-reset tooltip border-box white ${trad ? 'tastoVerde' : 'tastoArancio'} bn br3 pointer bordoColScrittaDef-10 w-25 w-25-m w-20-l bordoColScrittaDef-10`;

    return (
        <>
            <div className='flex items-center' aria-busy={inCorso}>
                <input
                    type='text'
                    aria-label='Codice da cui riciclare le traduzioni'
                    value={codDaRiciclare}
                    onChange={(evt) => setCodDaRiciclare(evt.target.value)}
                    autoComplete='off'
                    disabled={inCorso}
                    className='input-reset bn fl black-80 sfondoBiancoTema pa3 lh-solid w-100 w-75-m w-80-l br2-ns br--left-ns'
                />
                <button
                    className={classe}
                    aria-label={trad ? 'Traduzioni complete' : 'Ricicla traduzioni'}
                    onClick={ricicla}
                    disabled={inCorso || trad}
                >
                    {trad ? 'done' : inCorso ? 'hourglass_empty' : 'recycling'}
                </button>
            </div>
            {/* Le righe DataGrid trasformate conterrebbero il posizionamento fixed. */}
            <Portal>
                <Snackbar
                    open={Boolean(errore)}
                    onClose={() => setErrore('')}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert severity='error' onClose={() => setErrore('')}>
                        {errore}
                    </Alert>
                </Snackbar>
            </Portal>
        </>
    );
}

export default RiciclaCiecamente;
